import api from "../axiosInstance";

/**
 * Admin API Service
 * Fixed syntax and proper endpoints
 */

// ========== ORDERS ENDPOINTS ==========

// Get all orders (admin only)
export const getAllOrders = async () => {
    const response = await api.get("/admin/orders/all");
    return response.data;
};

// Get pending orders (admin only)
export const getPendingOrders = async () => {
    const response = await api.get("/admin/orders/pending");
    return response.data;
};

// Get approved orders (admin only)
export const getApprovedOrders = async () => {
    const response = await api.get("/admin/orders/approved");
    return response.data;
};

// Get delivered orders (admin only)
export const getDeliveredOrders = async () => {
    const response = await api.get("/admin/orders/delivered");
    return response.data;
};

// Get cancelled orders (admin only)
export const getCancelledOrders = async () => {
    const response = await api.get("/admin/orders/cancelled");
    return response.data;
};

// Approve order (admin only)
export const approveOrder = async (orderId) => {
    const response = await api.post(`/admin/orders/${orderId}/approve`);
    return response.data;
};

// Reject order (admin only)
export const rejectOrder = async (orderId, reason) => {
    const response = await api.post(`/admin/orders/${orderId}/reject`, {
        reason: reason || "Order rejected by admin"
    });
    return response.data;
};

// ========== MEMORIAL (QR CODE) MANAGEMENT ==========

// Delete memorial/QR code (admin only)
export const deleteMemorial = async (memorialId) => {
    const response = await api.delete(`/admin/memorials/${memorialId}`);
    return response.data;
};

// Get all memorials (admin only)
export const getAllMemorials = async () => {
    const response = await api.get("/admin/memorials");
    return response.data;
};

// ========== DASHBOARD STATS ==========

export const getDashboardStats = async () => {
    try {
        // Get all orders to calculate stats
        const allOrders = await getAllOrders();
        const pendingOrders = allOrders.filter(o =>
            o.status === 'PENDING' || o.status === 'pending'
        );
        const approvedOrders = allOrders.filter(o =>
            o.status === 'APPROVED' || o.status === 'approved'
        );

        return {
            totalOrders: allOrders.length,
            pendingOrders: pendingOrders.length,
            approvedOrders: approvedOrders.length,
        };
    } catch (err) {
        console.error('Error getting dashboard stats:', err);
        return {
            totalOrders: 0,
            pendingOrders: 0,
            approvedOrders: 0,
        };
    }
};

// ========== LEGACY FUNCTIONS (Keep for backward compatibility) ==========

// OLD: Update order status via PATCH (if backend still supports this)
export const updateOrderStatus = async (orderId, status) => {
    const response = await api.patch(`/orders/admin/${orderId}/status`, null, {
        params: { status }
    });
    return response.data;
};

// Generate QR code for order - NOT IMPLEMENTED
export const generateQrCode = async (orderId) => {
    const response = await api.post(`/admin/orders/${orderId}/generate-qr`);
    return response.data;
};